import React, { useState } from "react";
import { toast } from "react-toastify";
import { generateBatch } from "../../services/creativeService";

const RATIOS = ["1:1", "4:5", "9:16", "16:9"];
const COUNTS = [2, 4, 6, 8, 12];

const CreativeStudio = () => {
  const [prompt, setPrompt] = useState("");
  const [type, setType] = useState("image");
  const [aspect, setAspect] = useState("1:1");
  const [count, setCount] = useState(4);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  const setKind = (k) => { setType(k); setAspect(k === "video" ? "9:16" : "1:1"); if (k === "video" && count > 4) setCount(4); };

  const generate = async () => {
    if (!prompt.trim()) return toast.warn("Décrivez le produit / visuel.");
    setLoading(true); setResults([]);
    try {
      const res = await generateBatch({ prompt: prompt.trim(), count, aspectRatio: aspect, type });
      const ok = (res?.results || []).filter((r) => r.ok && r.url);
      setResults(ok);
      ok.length ? toast.success(`${ok.length} variations générées`) : toast.error("Aucune image générée.");
    } catch (e) {
      toast.error(e?.response?.data?.message || "Génération impossible.");
    } finally { setLoading(false); }
  };

  return (
    <div className="p-2">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-[#221C51]">Studio créatif IA</h2>
        <p className="text-sm text-gray-400 mt-0.5">Générez un lot de variations d'annonces à partir d'un seul prompt.</p>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 mb-5">
        <label className="block text-sm font-semibold text-[#221C51] mb-1">Décrivez le produit / visuel</label>
        <textarea
          value={prompt} onChange={(e) => setPrompt(e.target.value)} rows={2}
          placeholder="baskets blanches lifestyle urbain, jeune public"
          className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-xl focus:outline-none focus:border-[#221C51] resize-none"
        />
        <div className="flex flex-wrap gap-6 mt-4">
          <div>
            <p className="text-xs font-semibold text-gray-500 mb-2">Type</p>
            <div className="flex gap-2">
              {[["image", "🖼️ Image"], ["video", "🎬 Vidéo/UGC"]].map(([k, l]) => (
                <button key={k} onClick={() => setKind(k)} className={`px-3 py-1.5 rounded-lg text-sm font-medium border ${type === k ? "bg-[#221C51] text-white border-[#221C51]" : "border-gray-200 text-gray-600"}`}>{l}</button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold text-gray-500 mb-2">Format</p>
            <div className="flex gap-2">
              {RATIOS.map((r) => (
                <button key={r} onClick={() => setAspect(r)} className={`px-3 py-1.5 rounded-lg text-sm font-medium border ${aspect === r ? "bg-[#221C51] text-white border-[#221C51]" : "border-gray-200 text-gray-600"}`}>{r}</button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold text-gray-500 mb-2">Nombre de variations</p>
            <div className="flex gap-2">
              {COUNTS.map((c) => (
                <button key={c} onClick={() => setCount(c)} className={`w-9 h-9 rounded-lg text-sm font-medium border ${count === c ? "bg-[#221C51] text-white border-[#221C51]" : "border-gray-200 text-gray-600"}`}>{c}</button>
              ))}
            </div>
          </div>
        </div>
        <button onClick={generate} disabled={loading} className="mt-5 px-6 py-2.5 bg-[#221C51] text-white text-sm font-semibold rounded-xl hover:bg-[#2e265e] disabled:opacity-50">
          {loading ? `Génération de ${count}…` : `Générer ${count} variations`}
        </button>
      </div>

      {loading && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {Array.from({ length: count }).map((_, i) => (
            <div key={i} className="aspect-square rounded-xl bg-gray-100 animate-pulse" />
          ))}
        </div>
      )}

      {results.length > 0 && !loading && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {results.map((r, i) => (
            <a key={i} href={r.url} target="_blank" rel="noreferrer" className="block rounded-xl overflow-hidden border border-gray-200 hover:shadow-lg transition">
              {r.type === "video" ? (
                <div className="w-full aspect-square flex flex-col items-center justify-center bg-gray-50 text-[#221C51]">
                  <span className="text-4xl">▶</span>
                  <span className="text-xs mt-1 font-medium">Voir la vidéo</span>
                </div>
              ) : (
                <img src={r.url} alt={`Variation ${i + 1}`} className="w-full aspect-square object-cover" />
              )}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default CreativeStudio;
